import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 7em 2em 4em;

    .header {
        position: relative;

        .description {
            text-align: center;
            font-size: 1em;
            line-height: 140%;
            color: #111111;
        }

        .apostrophe {
            position: absolute;
            color: #BA9449;

            .quote {
                max-width: 5em;
            }

            &.top {
                top: -5.5em;
                left: -3em;
            }

            &.bottom {
                bottom: -5.5em;
                right: -4em;
            }
        }
    }

    .section-list {
        padding-top: 4em;

        .headline {
            font-size: 1.4em;
        }

        .subheadline {
            font-size: 1.4em;
        }
    }

    .section-control {
        padding-top: 2em;

        .expand-state {
            .button-icon-after {
                transform: scaleY(-1);
            }
        }
    }

    @media all and (max-width: ${variables.tabletS}) {
        .header {
            .apostrophe {
                .quote {
                    max-width: 4.5em;
                }

                &.top {
                    top: -5.5em;
                    left: -2em;
                }

                &.bottom {
                    bottom: -5.5em;
                    right: -2em;
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        padding: ${variables.sectionPaddingMobile};

        .section-list {
            padding-top: 2em;
        }

        .header {
            .description {
                text-align: left;
            }
        }
    }
`;
